<ion-row
  class="payment-dashboard-row touch"
  (click)="goToAllInvoices()"
  [ngClass]="{
    green: customerMetrics.creditStatus === CreditStatus.active,
    yellow: customerMetrics.creditStatus === CreditStatus.softHold,
    red: customerMetrics.creditStatus === CreditStatus.onHold,
  }"
>
  <ion-col size="12">
    <ion-row data-cy="account-activity-row-customer-information">
      <strong data-cy="account-activity-row-customer-name">
        {{ customerMetrics.customerName | titlecase }}
      </strong>
      <p data-cy="account-activity-row-customer-number">
        #{{ customerMetrics.customerNumber }}
      </p>
    </ion-row>

    <ion-row>
      <p
        class="credit-status"
        [ngClass]="{
          green: customerMetrics.creditStatus === CreditStatus.active,
          yellow: customerMetrics.creditStatus === CreditStatus.softHold,
          red: customerMetrics.creditStatus === CreditStatus.onHold,
        }"
        data-cy="account-activity-row-credit-status"
      >
        <span
          class="credit-status-circle"
          [ngClass]="{
            green: customerMetrics.creditStatus === CreditStatus.active,
            yellow: customerMetrics.creditStatus === CreditStatus.softHold,
            red: customerMetrics.creditStatus === CreditStatus.onHold,
          }"
        ></span>
        {{ customerMetrics.creditStatus }}
      </p>
      <p
        class="current-percentage"
        data-cy="account-activity-row-current-percentage"
      >
        {{ 'i18n.payments.paymentDashboard.tableHeaders.current' | translate }}:
        {{ customerMetrics.currentPercentage }}%
      </p>
    </ion-row>
  </ion-col>

  <ion-col size="5.5">
    <p data-cy="account-activity-row-open-invoices">
      {{
        'i18n.payments.paymentDashboard.tableHeaders.openInvoices' | translate
      }}:
      {{ customerMetrics.openInvoices }}
    </p>
    <p
      data-cy="account-activity-row-unused-credits
    "
    >
      {{
        'i18n.payments.paymentDashboard.tableHeaders.unusedCredits' | translate
      }}:
      {{ customerMetrics.unusedCredits }}
    </p>
    <p data-cy="account-activity-row-payment-method">
      {{ 'i18n.payments.paymentDashboard.tableHeaders.pMethod' | translate }}:
      {{ customerMetrics.paymentMethod }}
    </p>
  </ion-col>

  <ion-col size="5.5">
    <p data-cy="account-activity-row-account-balance">
      {{
        'i18n.payments.paymentDashboard.tableHeaders.accountBal' | translate
      }}:
      {{ customerMetrics.accountBalance | currency }}
    </p>
    <p data-cy="account-activity-row-current-balance">
      {{
        'i18n.payments.paymentDashboard.tableHeaders.currentBal' | translate
      }}:
      {{ customerMetrics.currentBalance | currency }}
    </p>
    <p data-cy="account-activity-row-overdue-balance">
      {{
        'i18n.payments.paymentDashboard.tableHeaders.overdueBal' | translate
      }}:
      {{ customerMetrics.overDueBalance | currency }}
    </p>
  </ion-col>

  <ion-col size="1" data-cy="chevron-next">
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </ion-col>
</ion-row>
